<template>
    <div>
        <Dialog :show-close-button="true" :show="show"
                :has-backdrop="true" width="90%" @close="$emit('close')">
            <div class="video-dialog-container">
                <div>
                    <span @click="$emit('previous')"
                          class="icon arrow icon-arrow-left"></span>
                </div>
                <div>
                    <video v-if="!url.includes('youtube')" preload="metadata" controls autoplay>
                        <source :src="url" type="video/mp4">
                    </video>
                    <iframe width="800" height="600" v-if="url.includes('youtube')" :src="url">
                    </iframe>
                </div>
                <div>
                    <span @click="$emit('next')"
                          class="icon arrow icon-arrow-right"></span>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script>
    import Dialog from "./Dialog";

    export default {
        name: "VideoDialog",
        components: {
            Dialog
        },
        props: {
            show: Boolean,
            url: {
                required: true,
                type: String
            }
        }
    }
</script>

<style lang="scss" scoped>

    .video-dialog-container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    video {
        max-width: 100%;
        max-height: 100%;
    }

    iframe {
        margin: auto;
    }

    ::v-deep .modal-container {
        display: flex;
        flex-flow: column;

        .title {
            margin-bottom: 20px;
        }
    }

    .arrow {
        font-size: 1.2em;
        margin: 1em;
        position: absolute;
        top: unset;
        right: unset
    }
    .icon-arrow-left{
        left: 0;
    }
    .icon-arrow-right{
        right: 0;
    }

    @media only screen and (max-width: 1200px) {
        .arrow{
            margin: 0;
        }
    }
</style>